/* eslint-disable-next-line import/prefer-default-export */
export const getCampaignManagerOption = user => ({
  value: user.pk,
  label: [user.first_name, user.last_name].join(' ').trim(),
});
